export const errorMessage: Record<string, string> = {
  'server_error': 'Server error',
  'auth_error': 'Wrong login or password',
  'stream_already_queued': 'Other stream already queued. Disabled here'
}